import React, { useState } from "react";
import { Link, Redirect, useLocation, useHistory } from "react-router-dom";
import MaskedInput from "react-text-mask";
import PropTypes from "prop-types";
import isMobilePhone from "../../../utils/isMobilePhone";

import PayungTerbang from "../../../assets/images/login-payung-terbang.svg";
import Gelombang from "../../../assets/images/login-gelombang.svg";
import tokoAll from "../../../assets/images/login-tokoo.svg";

import {
  Button,
  OutlinedInput,
  InputLabel,
  InputAdornment,
  FormControl,
  Divider,
  FormHelperText,
  CircularProgress,
} from "@material-ui/core";

import { WhatsApp } from "@material-ui/icons";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import PageLoading from "../../../components/appLoading";
import useStyles from "./styles";
import Header from "../../../components/molecules/navbarLogReg";
import Header1 from "../../../components/molecules/LoginNav/header";

import Footer from "../../../components/molecules/LoginNav/footer";

import {
  firefunctions,
  useFirebase,
} from "../../../components/firebase/FirebaseProvider";

import ReCAPTCHA from "react-google-recaptcha";
import recaptchaSiteKey from "../../../config/Google/recaptcha";

const NumberFormatCustom = (props) => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        "+",
        /[1-9]/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        "-",
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      guide={false}
    />
  );
};

NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const Forgot = () => {
  const classes = useStyles();
  const [year] = useState(new Date().getFullYear());
  const theme = useTheme();
  const history = useHistory();
  const matches = useMediaQuery(theme.breakpoints.up("tablet"));
  const location = useLocation();

  const { loading, user } = useFirebase();

  const [isSubmitting, setSubmitting] = useState(false);

  const [values, setValues] = useState({
    no_hp: "",
    errorType: "",
    errorMessage: "",
  });

  const [recaptchaToken, setRecaptchaToken] = useState(null);
  
  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const exp = /-/g;

  const handleChange = (prop) => (event) => {
    setValues({
      ...values,
      [prop]: event.target.value,
      errorStatus: false,
      errorType: "",
      errorMessage: "",
    });
  };

  const handleError = (err) => {
    setValues({
      ...values,
      errorStatus: true,
      errorType:
        err === "password atau nomor handphone tidak tepat"
          ? "wa"
          : err === "No WhatsApp wajib diisi"
          ? "wa kosong"
          : err === "No Whatsapp tidak valid"
          ? "wa invalid"
          : err === "nomor handphone belum terdaftar"
          ? "Nomor Ini Belum Terdaftar"
          : null,
      errorMessage: err,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const { no_hp } = values;
      let phoneRaw = no_hp.replace(exp, "");

      if (!no_hp) {
        throw new Error("No WhatsApp wajib diisi");
      } else if (!isMobilePhone(phoneRaw)) {
        throw new Error("No Whatsapp tidak valid");
      }

      if (!recaptchaToken) {
        throw new Error('Please complete the CAPTCHA.');
    }

      const sendOTP = firefunctions.httpsCallable("sendOTP");
      const res = await sendOTP({
        no_hp: phoneRaw,
        recaptcha_token: recaptchaToken
      });
      let expired = Date.now() + 5 * 60 * 1000;

      history.push(`/login/forgot/${phoneRaw}/${expired}`);
      setSubmitting(false);
    } catch (err) {
      console.log(err.message);
      setSubmitting(false);
      handleError(err.message);
    }
    setSubmitting(false);
  };

  if (loading) {
    return <PageLoading />;
  }

  if (user) {
    const redirectTo =
      location.state && location.state.from && location.state.from.pathname
        ? location.state.from.pathname
        : "/";
    return <Redirect to={redirectTo} />;
  }
  // #kb9NKWW22s0IXZhQ00DF-HBd2o60PQIWSu1y4hE45-1
  return (
    <div className={classes.root}>
      <div className={classes.main}>
        {matches ? (
          <Header1 nameStatus={"Lupa Password"} />
        ) : (
          <Header nameStatus={"Lupa Password"} />
        )}
        <div className={classes.body}>
          <div className={classes.box}>
            <div className={classes.box_container}>
              <div className={classes.box_head}>
                <div className={classes.box_head_logo}>
                  <img src={PayungTerbang} alt="payung_terbbangg" />
                </div>
                <div className={classes.box_head_text}>
                  <h1>Lupa Password?</h1>
                  <p>Masukkan nomor telepon yang terdaftar di Tokorame</p>
                </div>
              </div>
              <Divider />
              <div className={classes.container_form}>
                <form className={classes.box_form} onSubmit={handleSubmit}>
                  <FormControl
                    variant="outlined"
                    fullWidth
                    className={classes.input_form}
                    style={{ marginBottom: "25px" }}
                    disabled={isSubmitting}
                    error={
                      values.errorStatus
                        ? values.errorType === "wa" ||
                          values.errorType === "wa kosong" ||
                          values.errorType === "wa invalid" ||
                          values.errorType === "Nomor Ini Belum Terdaftar"
                          ? values.errorStatus
                          : values.errorMessage
                        : null
                    }
                  >
                    <InputLabel htmlFor="outlined-adornment-wa">
                      Nomor WA
                    </InputLabel>
                    <OutlinedInput
                      value={values.no_hp}
                      autoFocus={values.autoFocus}
                      id="outlined-adornment-wa"
                      label="Nomor WA"
                      placeholder="+62-852-1234-5678"
                      onChange={handleChange("no_hp")}
                      disabled={isSubmitting}
                      inputComponent={NumberFormatCustom}
                      startAdornment={
                        <InputAdornment position="start">
                          <WhatsApp />
                        </InputAdornment>
                      }
                    ></OutlinedInput>
                    {values.errorStatus ? (
                      values.errorType === "wa" ||
                      values.errorType === "wa kosong" ||
                      values.errorType === "wa invalid" ||
                      values.errorType === "Nomor Ini Belum Terdaftar" ? (
                        <FormHelperText>{values.errorMessage}</FormHelperText>
                      ) : (
                        <FormHelperText>{values.errorMessage}</FormHelperText>
                      )
                    ) : null}
                  </FormControl>
                  <div className={classes.bottom_form}>
                    <div className={classes.forgot_password}>
                      Sudah punya akun?
                      <Link
                        to=""
                        onClick={() => history.push("/login")}
                        className={classes.link}
                      >
                        Login
                      </Link>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            marginTop: "8px"
                        }}
                    >
                        <ReCAPTCHA
                            sitekey={recaptchaSiteKey}
                            onChange={handleRecaptchaChange}
                        />
                    </div>
                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={isSubmitting}
                      style={{
                        position: "relative",
                        width: "100%",
                        letterSpacing: "1px",
                        fontWeight: "bold",
                        borderRadius: "8px",
                        paddingTop: "12px",
                        paddingBottom: "12px",
                        marginTop: "10px",
                        marginBottom: "20px",
                      }}
                    >
                      {isSubmitting === true && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                      {!isSubmitting ? "kirim otp" : null}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <span className={classes.copyright}>
            © Hak Cipta PT. Tokorame Anugerah Sejahtera - {year}
          </span>
          <div className={classes.gelombang}>
            <img src={Gelombang} alt="gelombang" />
          </div>
          <div className={classes.toko}>
            <img src={tokoAll} alt="tokoo" />
          </div>
        </div>
      </div>
      {matches ? <Footer /> : null}
    </div>
  );
};

export default Forgot;
